export function obterListaTipoEvento() {
  return (
    [
      { label: 'Cancelamento', value: '110111' },
      { label: 'Carta de Correção', value: '110110' },
    ]
  );
}
